import { useParams } from 'react-router-dom';
import { useGetPersonListQuery } from 'graphql/generates';
import { getGraphQLClient } from 'graphql/graphQLClient';

export const usePersonList = (options?: { isSalesforce?: boolean }) => {
  const { householdId } = useParams<{ householdId: string }>();

  const query = useGetPersonListQuery(
    getGraphQLClient(),
    {
      householdId: householdId ?? '',
      isSalesforce: options?.isSalesforce,
    },
    {
      enabled: !!householdId,
      select: (response) => response.household.basicData.personInHouseholdList,
    },
  );

  return {
    ...query,
    data: query.data || [],
  };
};
